// extracted by mini-css-extract-plugin
export var searchHeader = "_8f-0";
export var searchHeaderDark = "_8f-1";